import {
  Badge,
  Button,
  CloseButton,
  Divider,
  HStack,
  Text,
  VStack,
} from '@gazin/ecommerce-ui'
import { Fragment } from 'react'
import {
  Filter,
  SelectedFilters,
} from 'src/services/searchProducts/dtos/search-products-response'
import { formatarPreco } from 'src/util/formatar'
import { FilterProduct as FilterProductProps } from '../../templates/SearchAndCategory'
import { Accordion } from '../accordion'
import FilterProduct, { RemoveFilter } from './filterProduct'
import { getOpenFilterIndexes } from 'src/util/searchAndCategory/openFilterIndexes'

export type MinimumAndMaximumProductPrice = {
  min: number
  max: number
}

type BarraFiltrosProdutosProps = {
  arrayFilters: Partial<FilterProductProps>[]
  clearFilters: () => void
  filters: Filter[]
  removeFilter: (index: number | RemoveFilter) => void
  selectedFilters?: SelectedFilters[]
  selectFilter: ({
    attribute,
    id_atributo,
    id_valor_unidade,
    label,
    tipo,
    valor_maximo,
    valor_minimo,
  }: FilterProductProps) => void
}

export default function BarraFiltrosProdutos({
  arrayFilters,
  clearFilters,
  filters,
  removeFilter,
  selectedFilters,
  selectFilter,
}: BarraFiltrosProdutosProps) {
  const accordionDefaultIndex = getOpenFilterIndexes(filters)

  return (
    <VStack w="100%">
      <VStack bg="transparent" gap="2rem">
        {arrayFilters && arrayFilters.length > 0 && (
          <VStack w="100%" h="fit-content" gap="1rem" alignItems="flex-start">
            <Text
              mb={0}
              fontSize="0.875rem"
              fontFamily="body"
              lineHeight="1.5rem"
              color="neutral.600"
              fontWeight="600"
            >
              Filtros selecionados
            </Text>
            <HStack
              mt="0rem !important"
              flexWrap="wrap"
              h="fit-content"
              w="100%"
              columnGap="0.5rem"
              rowGap="1rem"
            >
              {arrayFilters?.map((filtro: any, key_filtro: any) => (
                <Badge
                  variant="outline"
                  rounded="31.25rem"
                  py="0.375rem"
                  px="0.75rem"
                  pr="0.875rem"
                  bg="white"
                  border="0.0625rem solid neutral.600"
                  display="flex"
                  alignItems="center"
                  fontFamily="body"
                  fontSize="0.75rem"
                  lineHeight="0.9rem"
                  fontWeight="400"
                  gap="0.5rem"
                  key={`filtro-${key_filtro}-${filtro.descricao}`}
                >
                  {filtro.valor_minimo && filtro.valor_minimo != '' ? (
                    filtro.valor_maximo && filtro.valor_maximo != '' ? (
                      <Text mb={0}>{`${
                        filtro.descricao == 'Preço'
                          ? formatarPreco(filtro.valor_minimo)
                          : filtro.valor_minimo
                      } - ${
                        filtro.descricao == 'Preço'
                          ? formatarPreco(filtro.valor_maximo)
                          : filtro.valor_maximo
                      }`}</Text>
                    ) : (
                      <Text mb={0}>{`${filtro.valor_minimo}`}</Text>
                    )
                  ) : filtro.label && filtro.label != '' ? (
                    <Text
                      mb={0}
                      textTransform="initial"
                      maxW="16rem"
                      w="100%"
                      textOverflow="ellipsis"
                      overflow="clip"
                      minH="16px"
                      textAlign="center"
                    >{`${
                      filtro.type === 'continuous'
                        ? filtro.label
                        : `${filtro.descricao}: ${filtro.label}`
                    }`}</Text>
                  ) : null}
                  <CloseButton
                    size="md"
                    w="0.7rem"
                    h="0.7rem"
                    objectFit="contain"
                    overflow={'hidden'}
                    _hover={{ bg: 'transparent' }}
                    onClick={() => removeFilter(key_filtro)}
                  />
                </Badge>
              ))}
            </HStack>
            <Button
              variant="ghost"
              color="primary.500"
              fontSize="0.875rem"
              mt="1rem"
              fontWeight="600"
              lineHeight="24px"
              _hover={{ bg: 'transparent' }}
              h="fit-content"
              px={0}
              alignItems="flex-start"
              justifyContent="flex-start"
              onClick={clearFilters}
            >
              Limpar filtros
            </Button>
          </VStack>
        )}
        <VStack>
          <Accordion defaultIndex={accordionDefaultIndex}>
            {filters?.map((item: Filter, index: any) => (
              <Fragment key={`${index}-${item.id}`}>
                <FilterProduct
                  filter={item}
                  keyFilter={index}
                  removeFilter={removeFilter}
                  selectedFilters={selectedFilters}
                  selectFilter={selectFilter}
                />

                <Divider
                  m={0}
                  bg="neutral.800"
                  opacity={1}
                  w="100%"
                  display={`${filters.length - 1 === index ? 'none' : 'block'}`}
                />
              </Fragment>
            ))}
          </Accordion>
        </VStack>
      </VStack>
    </VStack>
  )
}
